module.exports = __webpack_public_path__ + "static/bg-iridium-1dfeba7e4df2af171a140b5948214316.webp";